module.exports = __webpack_public_path__ + "static/media/whitelogo.6614c159.png";